var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProceed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 106.444,
    height: 91.253,
    viewBox: "0 0 106.444 91.253",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "proceed",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chevrons-right",
    d: "M65.514,1.594l.714.63L104.2,40.2a7.6,7.6,0,0,1,.63,10.026l-.63.714L66.228,88.919A7.6,7.6,0,0,1,54.834,78.893l.63-.714L88.087,45.572l-32.6-32.607a7.6,7.6,0,0,1-.63-10.026l.63-.714a7.6,7.6,0,0,1,10.026-.63Zm-53.168,0,.714.63L51.037,40.2a7.6,7.6,0,0,1,.63,10.026l-.63.714L13.059,88.919A7.6,7.6,0,0,1,1.666,78.893l.63-.714L34.919,45.572,2.319,12.965a7.6,7.6,0,0,1-.63-10.026l.63-.714a7.6,7.6,0,0,1,10.026-.63Z",
    transform: "translate(0.014 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProceed);
export default __webpack_public_path__ + "static/media/proceed.67fe2f9a26e49b23a00a2dcc6ef194e5.svg";
export { ForwardRef as ReactComponent };